/**
 * Created by Mark on 17/04/2017.
 */

import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    LOCALE_UPDATE: 'LOCALE_UPDATE',
    TRANSLATION_UPDATE :'TRANSLATIONS_UPDATE',
    GET_ADMIN_TRANSLATIONS: ENVIRONMENT_CONSTANTS.BASE_URL  + '/admintranslationController/get/translations',
    GET_MODULE_TRANSLATIONS: ENVIRONMENT_CONSTANTS.BASE_URL + '/admintranslationController/getModules'
}


// WEBPACK FOOTER //
// ./src/constants/internationalization.js